<template>
    <div id="DentistCoverageAlert" v-show="show">
      <hp5-alert type="info" hide-alert-text :show-alert="true">
        <span> <span class="bold">Coverage </span> Your insurance may only cover part of your treatment by the dentists listed. Check your </span>
        <a href="/my/plan-overview/summary.html">insurance plan</a>
        <span> for more information.</span>
      </hp5-alert>
    </div>
</template>
  
<script setup>

      const searchTypeSnapshot = ref('')
      const { context, searchResults, plan } = useFCPModel()
      const type = computed(() => context.value.type)
      const isDental = computed(() => searchTypeSnapshot.value == 'dental' || searchTypeSnapshot.value == 'dentist')
      const show = computed(() => (plan.value ? plan.value.practiceType == 'Medical' && isDental.value : false))
  
      /**
       * Take a snapshot of the search type that was used during the most recent search.
       * We don't want the alert to show up or hide by observing the search type in the
       * criteria, or we would see the alert show up  in the UI prior to a search.
       */
      const snapshotSearchType = () => {
        if (type.value) {
          searchTypeSnapshot.value = type.value
        }
      }
  
      watch(searchResults, () => {
        snapshotSearchType()
      })

</script>
  
<style scoped>
  .bold {
    font-weight: bold;
  }
</style>